import { Component, ChangeDetectionStrategy } from '@angular/core';
import { NgIf } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'formly-field-button',
  standalone: true,
  imports: [MatButtonModule, NgIf],
  template: `
    <div class="formly-field-button-container">
      <button
        *ngIf="!props['stroked']"
        mat-raised-button
        color="primary"
        [type]="props.type || 'button'"
        [disabled]="props.disabled"
        (click)="props.onClick(field, $event)">
        {{ props.text }}
      </button>
      <button
        *ngIf="props['stroked']"
        mat-stroked-button
        color="primary"
        [type]="props.type || 'button'"
        [disabled]="props.disabled"
        (click)="props.onClick(field, $event)">
        {{ props.text }}
      </button>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [`
    .formly-field-button-container {
      display: flex;
      justify-content: flex-end;
    }
  `],
})
export class FormlyFieldButton extends FieldType<FieldTypeConfig> {
  onClick(){
  }
}
